<template>
  <figure class="c-avatar" :id="`avatar_${_uid}`" :class="imageClass">
    <loading v-if="loading"/>
    <img :src="userAvatar" :alt="imgAlt" v-else>
  </figure>
</template>

<script>
import { mapState } from "vuex";
import filesApi from "@/api/files";
export default {
  name: "UserAvatar",

  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      userAvatar: null,
      loading: true,
      imageClass: null
    };
  },
  created() {
    if (!this.user.avatar && !this.user.avatar_id) {
      this.userAvatar =
        "https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp";
      this.applyStyleClass();
      this.loading = false;
    } else {
      const id = this.user.avatar ? this.user.avatar.id : this.user.avatar_id;
      this.getFile(id);
    }
  },

  beforeUpdate() {
    if (!this.user.avatar && !this.user.avatar_id) {
      this.userAvatar =
        "https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp";
        this.applyStyleClass();
      this.loading = false;
      return;
    } else {
      const id = this.user.avatar ? this.user.avatar.id : this.user.avatar_id;
      this.getFile(id);
    }
  },

  beforeDestroy() {
    this.fileId = null;
  },

  updated() {},

  computed: {
    imgAlt() {
      return `Avatar image of ${this.user.name}`;
    }
  },

  methods: {
    applyStyleClass() {
      const image = document.querySelector(`#avatar_${this._uid} img`);
      if (image) {
        this.imageClass = image.width > image.height ? "is-vert" : "is-horz";
      } else {
        this.imageClass = 'is-horz';
      }
    },
    getFile(fileId = null) {
      const vm = this;

      if (!fileId) {
        this.imageClass = 'is-horz';
        return "https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp";
      }
      setTimeout(function() {
        filesApi
          .read(fileId)
          .then(file => {
            filesApi
              .readLink(file.link)
              .then(response => {
                vm.setFileData(response.data);
              })
              .catch(err => {
                vm.loading = false;
                vm.userAvatar =
                  "https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp";
                this.imageClass = 'is-horz';
              });
          })
          .catch(err => {
            vm.loading = false;
            vm.userAvatar =
              "https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp";
            this.imageClass = 'is-horz';
          });
      }, 5);
    },

    setFileData(blob) {
      const vm = this;
      try {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function() {
          const base64data = reader.result;
          vm.userAvatar = base64data;
          vm.loading = false;
          // vm.userAvatar = "https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp";
          vm.applyStyleClass();
        };
      } catch (err) {
        vm.loading = false;
        vm.userAvatar =
          "https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp";
        vm.applyStyleClass();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * TODO: Should we put all the stylings for avatars in here?  They all seem to be rounded anyway...
 **/
.c-avatar {
  margin: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  overflow: hidden;
  display: inline-flex;
  align-items: center;

  img {
    @supports (object-fit: cover) {
      object-fit: cover;
      height: 100%;
      width: 100%;
      margin-left: 0;
    }
    @supports not (object-fit: cover) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.c-avatar {
  &.is-horz {
    img {
      height: auto;
      width: 100%;
    }
  }
  &.is-vert {
    img {
      height: 100%;
      width: auto;
    }
  }
  @supports (object-fit: cover) {
    &.is-horz,
    &.is-vert {
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>
